"use strict";

exports.__esModule = true;

var syllablesNum = function syllablesNum(str) {
  return str.split(/[aiouy]+e*|e(?!d$|ly).|[td]ed|le$/).length;
};

exports["default"] = [{
  test: function test(str) {
    return syllablesNum(str) > 3 && !(syllablesNum(str) < 5 && /y$/.test(str));
  },
  comp: function comp(str) {
    return "more " + str;
  },
  supr: function supr(str) {
    return "most " + str;
  }
}, {
  test: function test(str) {
    return syllablesNum(str) > 2 && /ing$/.test(str);
  },
  comp: function comp(str) {
    return "more " + str;
  },
  supr: function supr(str) {
    return "most " + str;
  }
}, {
  test: function test(str) {
    return syllablesNum(str) > 2 && /ed$/.test(str);
  },
  comp: function comp(str) {
    return "more " + str;
  },
  supr: function supr(str) {
    return "most " + str;
  }
}, {
  test: function test(str) {
    return /[^aeiouy][aeiouy][^rwaeiouy]$/.test(str);
  },
  comp: function comp(str) {
    return str.replace(/([^aeiouy])$/, "$1$1er");
  },
  supr: function supr(str) {
    return str.replace(/([^aeiouy])$/, "$1$1est");
  }
}, {
  test: function test(str) {
    return /y$/.test(str);
  },
  comp: function comp(str) {
    return str.replace(/y$/, "ier");
  },
  supr: function supr(str) {
    return str.replace(/y$/, "iest");
  }
}, {
  test: function test(str) {
    return /e$/.test(str);
  },
  comp: function comp(str) {
    return str.replace(/e$/, "er");
  },
  supr: function supr(str) {
    return str.replace(/e$/, "est");
  }
}, {
  test: function test(str) {
    return true;
  },
  comp: function comp(str) {
    return str + "er";
  },
  supr: function supr(str) {
    return str + "est";
  }
}];